module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (options.glyphiconClassName) { 
__p+='\n<i class="glyphicon '+
((__t=( options.glyphiconClassName ))==null?'':__t)+
'"></i>\n';
 } 
__p+='\n';
 if (state.label) { 
__p+='\n<span class="tl-label">'+
((__t=( state.label ))==null?'':__t)+
'</span>\n';
 } 
__p+='';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/vendor/treeline-shared-components/spinner-button/spinner-button.html
 ** module id = 36
 ** module chunks = 1 2 3 4 7 8 9 12 13 15 18 19 20 21 23 24 27 28 30 32 33 34 35 36 38 39 40 41 42 44 45 46 47 48 50 51 53 54 55 56 57 58 59 60 61 63 64 65 67 68 69 70 79 81 82 85 89 90 93 94 96 103 104 107 109 110 112 116 125 126 127 128
 **/